module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/exchangewithdrawal/addexchangewithdrawal/addexchangewithdrawal.component.css
// module id = ./src/app/exchangewithdrawal/addexchangewithdrawal/addexchangewithdrawal.component.css
// module chunks = main